import { Button } from '@components'
import { useAuthentication } from '@haus-storefront-react/hooks'
import { useTranslation } from 'react-i18next'
import styles from './LogoutButton.module.scss'

type LogoutButtonAttributes = {
  configStyles?: {
    buttonVariant?: {
      variant?: string
    }
  }
}

/**
 * Renders a logout button that signs the user out and redirects to the login URL.
 */
const LogoutButtonWidget = ({ configStyles }: LogoutButtonAttributes) => {
  const { t } = useTranslation()
  const { isLoading, logout } = useAuthentication({})
  const buttonVariant = configStyles?.buttonVariant?.variant ?? 'primary'

  const handleLogout = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault()
    await logout()
    window.location.href = t('urls.login')
  }

  return (
    <Button
      aria-label={t('account.accountDropdown.logout')}
      className={styles.button}
      loading={isLoading}
      variant={buttonVariant}
      onClick={handleLogout}
    >
      {t('account.accountDropdown.logout')}
    </Button>
  )
}

export default LogoutButtonWidget
